import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackPageView } from "@/services/analytics";
import { useFootfall } from "@/hooks/useFootfall";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import Blog from "@/pages/Blog";
import MyAppointments from "@/pages/MyAppointments";
import AdvisorDashboard from "@/pages/AdvisorDashboard";
import Profile from "@/pages/Profile";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

import Portfolio from "@/pages/Portfolio";
import Documents from "@/pages/Documents";

// Admin pages
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminUserDetail from "@/pages/admin/AdminUserDetail";
import AdminConsultations from "@/pages/admin/AdminConsultations";
import AdminConsultationDetail from "@/pages/admin/AdminConsultationDetail";
import AdminAdvisors from "@/pages/admin/AdminAdvisors";
import AdminAdvisorDetail from "@/pages/admin/AdminAdvisorDetail";
import AdminAppointments from "@/pages/admin/AdminAppointments";
import AdminKYC from "@/pages/admin/AdminKYC";
import AdminManagement from "@/pages/admin/AdminManagement";
import AdminChangePassword from "@/pages/admin/AdminChangePassword";
import AdminFootfall from "@/pages/admin/AdminFootfall";

export default function AppRouter() {
  const location = useLocation();

  // Track footfall in our backend
  useFootfall();

  // Track every route change as a GA4 page_view (fires once per navigation)
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  // Handle OAuth callback at any route (legacy hash-based fallback)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/google/callback" element={<AuthCallback />} />

      {/* Authenticated user */}
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/appointments" element={<MyAppointments />} />
      <Route path="/documents" element={<Documents />} />
      <Route path="/portfolio" element={<Portfolio />} />

      {/* Advisor portal */}
      <Route path="/advisor" element={<AdvisorDashboard />} />

      {/* Admin */}
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/users" element={<AdminUsers />} />
      <Route path="/admin/users/:userId" element={<AdminUserDetail />} />
      <Route path="/admin/consultations" element={<AdminConsultations />} />
      <Route path="/admin/consultations/:consultationId" element={<AdminConsultationDetail />} />
      <Route path="/admin/advisors" element={<AdminAdvisors />} />
      <Route path="/admin/advisors/:advisorId" element={<AdminAdvisorDetail />} />
      <Route path="/admin/appointments" element={<AdminAppointments />} />
      <Route path="/admin/kyc" element={<AdminKYC />} />
      <Route path="/admin/footfall" element={<AdminFootfall />} />
      <Route path="/admin/management" element={<AdminManagement />} />
      <Route path="/admin/change-password" element={<AdminChangePassword />} />

      <Route path="*" element={<Landing />} />
    </Routes>
  );
}
